// 代理級別共用(代理制度規則總表 v2.1 1.1:級別依位置決定,平台直屬為1級代理)
import i18n from '@/plugins/i18n'

const t = (...args) => i18n.global.t(...args)

// 身分文字:玩家顯示「玩家」,代理顯示「N級代理」
export function identityText(agentType, agentLevel) {
  if (agentType === 'member') return t('agentType_member')
  return agentLevel
    ? t('agentLevel_n', { input: agentLevel })
    : t('agentType_agent')
}

// 退水%固定顯示到小數點第2位,例如 80.00%;沒有值顯示 -
export function rateText(value) {
  if (value == null || value === '') return '-'
  return `${Number(value).toFixed(2)}%`
}

// 等待週結算的異動方式用詞(代理設定規範 三、3):bind / unbind / switch
export function pendingActionText(action) {
  return action ? t(`agentPending_${action}`) : ''
}

// 身分篩選選項:玩家、1級代理～N級代理(N = 開放的層數,由後端 levelSetting 取得)
export async function fetchIdentityOptions($api) {
  let openLevels = 10
  try {
    const { data } = await $api.get('admin/agent/setting/levelSetting')
    openLevels = data?.data?.openLevels || openLevels
  } catch (error) {
    console.log('error', error)
  }
  const options = [{ label: t('agentType_member'), value: 'member' }]
  for (let i = 1; i <= openLevels; i++) {
    options.push({ label: t('agentLevel_n', { input: i }), value: String(i) })
  }
  return options
}
